// ptMaster.js (Service File)
import axiosInstance from "../Axios";

function getPtMasters(pageNo = 1, params) {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }

    return axiosInstance.get("/pt-master", { params: queryParams });
  } catch (error) {
    console.log("Error while fetching PT master list:", error);
    throw error;
  }
}

function getPtMasterDetails(id) {
  try {
    return axiosInstance.get(`/pt-master/${id}`);
  } catch (error) {
    console.log("Error fetching PT master details:", error);
    throw error;
  }
}

function createPtMaster(data) {
  try {
    return axiosInstance.post("/pt-master", data);
  } catch (error) {
    console.log("Error while creating PT master:", error);
    throw error;
  }
}

function bulkUpsertPtMaster(data) {
  try {
    return axiosInstance.post("/pt-master/bulk", data);
  } catch (error) {
    console.log("Error while bulk upserting PT master:", error);
    throw error;
  }
}

function updatePtMaster(id, data) {
  try {
    return axiosInstance.put(`/pt-master/${id}`, data);
  } catch (error) {
    console.log("Error while updating PT master:", error);
    throw error;
  }
}

function deletePtMaster(id) {
  try {
    return axiosInstance.delete(`/pt-master/${id}`);
  } catch (error) {
    console.log("Error while deleting PT master:", error);
    throw error;
  }
}

function getZones() {
  try {
    return axiosInstance.get("/compliance/states");
  } catch (error) {
    console.log("Error while fetching state:", error);
    throw error;
  }
}

function getZoneDetails(id) {
  try {
    return axiosInstance.get(`/pt-master/zones/${id}`);
  } catch (error) {
    console.log("Error fetching zone details:", error);
    throw error;
  }
}

export {
  getPtMasters,
  getPtMasterDetails,
  createPtMaster,
  bulkUpsertPtMaster,
  updatePtMaster,
  deletePtMaster,
  getZones,
  getZoneDetails,
};